import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { JobSupport3fdjh0rbee4be as JobSupport } from './JobSupport.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally } from './CompletionState.mjs';
import { Job29shfjfygy86k as Job } from './Job.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function CompletableDeferred(parent) {
  parent = parent === VOID ? null : parent;
  return new (CompletableDeferredImpl())(parent);
}
var CompletableDeferredImplClass;
function CompletableDeferredImpl() {
  if (CompletableDeferredImplClass === VOID) {
    class $ extends JobSupport() {
      constructor(parent) {
        super(true);
        this.yv(parent);
      }
      lx() {
        return true;
      }
      vy() {
        return this.cy();
      }
      *wy($completion) {
        return yield* this.dy($completion);
      }
      s12(value) {
        return this.ux(value);
      }
      t12(exception) {
        return this.ux(new (CompletedExceptionally())(exception));
      }
    }
    initMetadataForClass($, 'CompletableDeferredImpl', VOID, VOID, [Job()], [0]);
    CompletableDeferredImplClass = $;
  }
  return CompletableDeferredImplClass;
}
//region block: exports
export {
  CompletableDeferred as CompletableDeferred2lnqvsbvx74d3,
};
//endregion

//# sourceMappingURL=CompletableDeferred.mjs.map
